import React, { useEffect, useState } from 'react'
import Text from '../../components/text/Text'
import discount from '../../assets/icons/icons-discount.svg'
import check from '../../assets/icons/icons-check.png'
import polygon from '../../assets/icons/icons-polygon.png'
import SquareCheckBox from '../../components/checkBox/SquareCheckBox'
import './SubscriptionDetail.css'
import locked from '../../assets/icons/icons-locked.png'

import { useLocation, useNavigate } from 'react-router-dom'
import { payPlan } from '../../services/amipos'
import { useLoadingContext } from '../../context/spinnerContext'
import { getLocal } from '../../Utils/Profile'
import { REACT_APP_FRONTEND_URL } from '../../services/constants'

const acceptTerms = localStorage.getItem('acceptTerms') === 'true'

export default function SubscriptionDetail() {
    const loadingContext = useLoadingContext()
    const navigation = useNavigate()
    const [selectedFeatureId, setSelectedFeatureId] = useState<number>(0)

    const { state } = useLocation()

    const [isPaying, setIsPaying] = useState<boolean>(false)
    const [accept, setAccept] = useState<boolean>(!!acceptTerms)

    const subscriptionDetail = [
        {
            featureId: 1,
            title: 'Plan contratado:',
            description: state?.planSelectedParam.planName,
        },
        {
            featureId: 2,
            title: 'Costo',
            subtitle: 'plan',
            description: `${state?.planSelectedParam.price.price} UF ${state?.planSelectedParam.price.label}`,
        },
        /* {
            featureId: 3,
            title: 'Costo',
            subtitle: 'complemento',
            description: '$XXX.XXX al año',
        }, */
        {
            featureId: 4,
            title: 'Subtotal',
            description: `${state?.planSelectedParam.price.price} UF ${state?.planSelectedParam.price.label}`,
        },
    ]
    const featureOptionPro = [
        {
            featureId: 1,
            title: 'Pago QR',
            text: 'Podrás cobrar a tus clientes con un sólo clic. Abre tu cámara, escanea el código y ya tienes tu pago.',
            active: true,
        },
        {
            featureId: 2,
            title: 'Resumen de ventas',
            text: 'Revisa el detalle de las ventas del día, la semana o el mes. Puedes elegir el período y ver el detalle de cada transacción.',
            active: true,
        },
        {
            featureId: 3,
            title: 'Anticipa tus pagos',
            text: 'Puedes solicitar pago anticipado o pronto pago, tu eliges.',
            active: true,
        },
        {
            featureId: 4,
            title: 'Sello ecofriendly',
            text: 'Responde una breve encuesta y obtén el sello ecofriendly si cumples con los criterios mínimos de cuidado del medio ambiente.',
            active: true,
        },
        {
            featureId: 5,
            title: 'Liquida productos próximos a vencer',
            text: 'Ideal para los comercios con merma, la liquidación te permite ofrecer productos a bajos precios para evitar su pérdida.',
            active: true,
        },
        {
            featureId: 6,
            title: 'Promociones',
            text: 'Haz descuentos en tus productos, atrae clientes con tus ofertas y mueve tu inventario.',
            active: true,
        },
        {
            featureId: 7,
            title: 'Marketplace amiPASS',
            text: 'Vende en nuestro marketplace, muestra tus productos, precios y configura tu propia tienda con retiro en el local o delivery.',
            active: true,
        },
        {
            featureId: 8,
            title: 'Delivery amiPASS',
            text: 'Si no tienes delivery propio, te ofrecemos una solución para despachar en un radio de 5 kilómetros alrededor de tu local.',
            active: true,
        },
        {
            featureId: 9,
            title: 'Incluye terminal BCI PAGO',
            text: 'Sin especificar',
            active: true,
        },
        {
            featureId: 10,
            title: 'Tu ecommerce',
            extra: 'Exclusivo plan PRO',
            text: 'Activa tu propio sitio web con e-commerce y vende con delivery amiPASS. \nRecibe pagos con tarjetas de crédito, débito o prepago sin necesidad de configuraciones complejas.',
            active: true,
            color: '#62B565',
        },
    ]
    const featureOptionStandard = [
        ...featureOptionPro.filter((item) => item.featureId !== 10),
        {
            featureId: 10,
            title: 'Tu ecommerce',
            extra: 'Exclusivo plan PRO',
            text: 'Activa tu propio sitio web con e-commerce y vende con delivery amiPASS. \nRecibe pagos con tarjetas de crédito, débito o prepago sin necesidad de configuraciones complejas.',
            active: false,
            color: '#565656',
        },
    ]
    useEffect(() => {
        if (isPaying) {
            const currentUser = localStorage.getItem('currentUser')

            const user = currentUser && JSON.parse(currentUser)
            const data = {
                commerceID: user?.sEstablecimiento,
                storeID: getLocal(),
                email: user.sEmailContacto,
                urlRedirect: `${REACT_APP_FRONTEND_URL}/?plan=success`,
                planID: state.planSelectedParam.planId,
                addons: [],
                modePlan: state.planSelectedParam.price.periodID,
            }

            payPlan(data)
                .then((response) => {
                    if (response.status === 200) {
                        window.location.href = response.data.urlRedirect
                        navigation(response.data.urlRedirect)
                    }
                })
                .catch(() => {
                    alert('Hubo un error al generar el pago, intente otra vez')
                })
                .finally(() => {
                    setIsPaying(false)
                    loadingContext?.onClose()
                })
        }
    }, [isPaying])

    if (!state.planSelectedParam) {
        navigation('/subscription')
        return <div />
    }

    const handleOnPay = () => {
        loadingContext?.onOpen()
        setIsPaying(true)
    }
    const formatDate = (dateString: string): string => {
        const [year, month, day] = dateString.split('-')
        return `${day}/${month}/${year}`
    }
    const featureOption =
        state.planSelectedParam.planId === '1'
            ? featureOptionPro
            : featureOptionStandard

    return (
        <div className="parent-subscription">
            <Text
                label="Resumen de tu suscripción:"
                fontSize={31}
                fontWeight={700}
                color={'#0086D6'}
                marginLeft={270}
                marginBottom={10}
            />
            <div className="subtract-white">
                <div className="sub-detial-ticket-top"></div>
                <div className="sub-detial-ticket-header-container">
                    <div className="sub-detial-ticket-header"></div>
                </div>
                <div className="sub-detial-ticket-content">
                    <div className="subscription-card">
                        {subscriptionDetail.map((item) => (
                            <div key={`${item.title}${item.featureId}`}>
                                <div className="sub-detail-justify-content">
                                    <div>
                                        <Text
                                            label={item.title}
                                            fontSize={18}
                                            fontWeight={600}
                                            color={'#9A9A9A'}
                                            marginBottom={
                                                item.featureId === 1 ? 10 : 0
                                            }
                                        />
                                        <Text
                                            label={item.subtitle}
                                            fontSize={18}
                                            fontWeight={600}
                                            color={'#9A9A9A'}
                                            marginBottom={6}
                                        />
                                    </div>
                                    <Text
                                        label={item.description}
                                        fontSize={18}
                                        fontWeight={600}
                                        color={'#565656'}
                                    />
                                </div>
                            </div>
                        ))}
                        <div className="line-2" />
                        <div className="sub-detail-flex-direction-row-commission pointer">
                            <img
                                src={discount}
                                className="sub-detail-commission-discount-style"
                            />
                            <Text
                                label="Revisa los detalles de nuestras comisiones AQUí"
                                fontSize={18}
                                fontWeight={400}
                                color={'#565656'}
                                variant={'underline-italic'}
                                marginTop={3}
                            />
                        </div>
                        <div className="sub-detail-justify-content">
                            <Text
                                label={'Vigencia'}
                                fontSize={18}
                                fontWeight={600}
                                color={'#9A9A9A'}
                                marginTop={30}
                                marginBottom={4}
                            />
                            <Text
                                label={formatDate(
                                    state.planSelectedParam.price.dueDate
                                )}
                                fontSize={18}
                                fontWeight={600}
                                color={'#565656'}
                                marginTop={30}
                                marginBottom={4}
                            />
                        </div>
                        <div className="line-2" />
                        <Text
                            label={'Funcionalidades activas'}
                            fontSize={20}
                            fontWeight={400}
                            color={'#565656'}
                            marginTop={10}
                            marginBottom={30}
                        />

                        {featureOption.map((item) => (
                            <div
                                key={`${item.title}${item.featureId}`}
                                className="sub-detail-feature-option-item"
                            >
                                <div
                                    className="sub-detail-flex-direction-row-subscription"
                                    onClick={() => {
                                        if (
                                            item.featureId === selectedFeatureId
                                        ) {
                                            setSelectedFeatureId(0)
                                        } else
                                            setSelectedFeatureId(item.featureId)
                                    }}
                                >
                                    <img
                                        src={item.active ? check : locked}
                                        className={`sub-check-icon ${
                                            item.extra &&
                                            'sub-detail-extra-icon-check'
                                        }`}
                                    />
                                    {item.extra ? (
                                        <div className="sub-detail-extra-container">
                                            <Text
                                                label={item.extra}
                                                fontSize={13}
                                                fontWeight={600}
                                                color={item.color}
                                                marginLeft={10}
                                                fontFamily="Poppins"
                                                lineHeight={1}
                                            />
                                            <Text
                                                label={item.title}
                                                fontSize={21}
                                                fontWeight={600}
                                                color={item.color}
                                                marginLeft={10}
                                                lineHeight={1}
                                                fontFamily="Poppins"
                                            />
                                        </div>
                                    ) : (
                                        <Text
                                            label={item.title}
                                            fontSize={21}
                                            fontWeight={600}
                                            color={'#0086D6'}
                                            marginLeft={10}
                                            lineHeight={1}
                                            fontFamily="Poppins"
                                            variant="sub-detail-item-title"
                                        />
                                    )}
                                    <div className="sub-detail-ver-mas-container">
                                        <Text
                                            label="ver más"
                                            marginTop={6}
                                            fontSize={14.5}
                                            fontWeight={600}
                                            color={'#565656'}
                                            fontFamily="Poppins"
                                            marginLeft={10}
                                            variant="sub-detail-ver-mas"
                                        />
                                        <img
                                            src={polygon}
                                            className="sub-detail-polygon-icon"
                                        />
                                    </div>
                                </div>
                                {selectedFeatureId === item.featureId && (
                                    <div className="subscription-feature-text">
                                        <Text
                                            label={item.text}
                                            fontSize={14}
                                            fontWeight={400}
                                            color={'#000000'}
                                            fontFamily="Poppins"
                                        />
                                    </div>
                                )}
                                <div className="subscription-line" />
                            </div>
                        ))}
                        <div className="sub-detail-flex-direction-row pointer">
                            <SquareCheckBox
                                checkId="reception24-7"
                                label={''}
                                onClick={() => setAccept(!accept)}
                                checked={accept}
                            />
                            <Text
                                as="link"
                                label={'Ver y aceptar ANEXO COMERCIAL'}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                                variant={'text-underline'}
                                //to="https://goolge.com"
                            />
                        </div>
                        <div className="pay-container pointer">
                            <div className="pay-button" onClick={handleOnPay}>
                                <Text
                                    label="PAGAR PLAN"
                                    color="white"
                                    fontSize={16}
                                    fontWeight={600}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
